module.exports = __webpack_public_path__ + "img/toe-egyptian.4fd8058d.svg";